// Infinite Scroll for ALFC Collection Pages - 2025-02-03 CW
if (window.location.pathname.includes('/collections/')) {
    document.addEventListener("DOMContentLoaded", function () {
        let infLog = false; // Set to true to debug
        let loading = false;
        let loadMoreButton = document.getElementById("load-more");

        let displayedCollections = new Set(); // Track grouped collections (grouped-rods, grouped-reels)
        let displayedProducts = new Set(); // Track all product IDs

        // Capture existing collections & products on initial page load
        document.querySelectorAll("#product-grid > li").forEach(product => {
            let collectionHandle = product.dataset.collectionHandle;
            let productId = product.dataset.productId;

            if (collectionHandle) displayedCollections.add(collectionHandle);
            if (productId) displayedProducts.add(productId);
        });
        
        if (infLog) {
            console.log("Initial displayed collections:", displayedCollections);
            console.log("Initial displayed products:", displayedProducts);   
        }

        function loadMoreProducts() {
            if (loading || !loadMoreButton || !loadMoreButton.dataset.nextUrl) return;
            loading = true;

            // Get the full next page URL (including facets)
            let nextUrl = new URL(loadMoreButton.dataset.nextUrl, window.location.origin);

            // Append current facet filters to the next page URL
            let currentParams = new URLSearchParams(window.location.search);
            currentParams.forEach((value, key) => {
                if (!nextUrl.searchParams.has(key)) {
                    nextUrl.searchParams.append(key, value);
                }
            });

            if (infLog) {
                console.log("Fetching next page with URL:", nextUrl.toString());
            }

            fetch(nextUrl.toString())
                .then(response => response.text())
                .then(data => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(data, "text/html");

                    let newProducts = doc.querySelectorAll("#product-grid > li");
                    let nextUrlElement = doc.querySelector("#load-more");

                    newProducts.forEach(product => {
                        let collectionHandle = product.dataset.collectionHandle;
                        let productId = product.dataset.productId;

                        if (collectionHandle && displayedCollections.has(collectionHandle)) {
                            if (infLog) {
                                console.warn("Skipping duplicate collection:", collectionHandle);
                            }
                            return;
                        }

                        if (!collectionHandle && productId && displayedProducts.has(productId)) {
                            if (infLog) {
                                console.warn("Skipping duplicate product:", productId);
                            }
                            return;
                        }

                        document.getElementById("product-grid").appendChild(product);
                        if (collectionHandle) displayedCollections.add(collectionHandle);
                        if (productId) displayedProducts.add(productId);
                    });

                    if (infLog) {
                        console.log("Updated displayed collections:", displayedCollections);
                        console.log("Updated displayed products:", displayedProducts);
                    }

                    if (nextUrlElement) {
                        loadMoreButton.dataset.nextUrl = nextUrlElement.dataset.nextUrl;
                    } else {
                        loadMoreButton.remove();
                    }

                    loading = false;
                })
                .catch(error => {
                    if (infLog) { 
                        console.error("Error loading products:", error);
                    }
                    loading = false;
                });
        }

        window.addEventListener("scroll", function () {
            let scrollPosition = window.innerHeight + window.scrollY;
            let triggerPosition = document.documentElement.offsetHeight - 500;

            if (scrollPosition >= triggerPosition) {
                loadMoreProducts();
            }
        });
    });
}